import React, { useEffect, useState } from "react";
import { GridActionsCellItem, useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import {
    requiredCell,
} from "../../js/utils/inputValidations";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ReplayIcon from '@mui/icons-material/Replay';
import { dateTimeToString, isArrayLength } from "../../js/utils/genericMethods";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { BasicTooltip } from "../Widgets/StyledComponents";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { updateEntityTree } from "../../js/redux/actions/userPref";
import { ButtonToolbar } from "../Widgets/Custom Inputs/Buttons";
import { useDebounceEffect } from "../../js/utils/customHooks";


const RecycleBinGrid = ({ label, baseURL, ...props }) => {
    const apiRef = useGridApiRef();
    const { OTEntityID } = useParams();
    const dispatch = useDispatch();

    const token = useSelector(state => state.auth.Token);
    const [forceGridRefresh, setForceGridRefresh] = useState(false);
    const [inSelection, setInSelection] = useState(false);
    const [selection, setSelection] = useState([]);
    const [onHoverDisableDropzone, setOnHoverDisableDropzone] = useState(false);
    console.log(onHoverDisableDropzone)
    function mouseEntering() {
        setOnHoverDisableDropzone(true);
    }
    function mouseLeaving() {
        setOnHoverDisableDropzone(false);
    }
    const deferEnter = useDebounceEffect(mouseEntering, 100);
    const deferLeave = useDebounceEffect(mouseLeaving, 100);

    useEffect(() => {
        handleCancelMoveClick();
    }, [setInSelection]);

    const handleSelectClick = () => {
        setInSelection(true);
    };

    const handleCancelMoveClick = () => {
        setInSelection(false);
        setSelection([]);
    };

    const handleRestoreClick = async () => {
        const url = "document/restoreSelectedDocuments";
        const documentsIDs = [...apiRef.current.getSelectedRows().keys()];
        if (documentsIDs.length === 0) {
            console.error("No files selected");
            return;
        }
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        }

        await Axios.post(url, documentsIDs, config);
        setForceGridRefresh(prev => !prev);
        dispatch(updateEntityTree());
        setInSelection(false);
        setSelection([]);
    };
    
    const gridSpecificColumns = [
        {
            field: "Filename",
            headerName: t("field.Filename"),
            editable: true,
            minWidth: 150,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "Value", "Value");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "DeletedOn",
            headerName: t("field.DeletedOn"),
            width: 150,
            editable: false,
            valueFormatter: params =>
                dateTimeToString(params.value, "DateTime"),
        },
        {
            field: "DeletedBy",
            headerName: t("field.DeletedBy"),
            width: 150,
            editable: false
        },
        {
            field: "CreatedBy",
            headerName: t("field.CreatedBy"),
            width: 150,
            editable: false
        },
        {
            field: "OriginalLocation",
            headerName: t("field.OriginalLocation"),
            width: 160,
            editable: false
        },
    ];

    const detailSpecificActionsColumns = (
        params,
        _editing
    ) => [
        <>
            {!params.row.OriginalLocation.includes('(') && !params.row.OriginalLocation.includes(')') ? <GridActionsCellItem
                label={t("common.Restore")}
                icon={
                    <BasicTooltip title={t("common.Restore")}>
                        <ReplayIcon />
                    </BasicTooltip>
                }
                onClick={async () => {
                    const config = {
                        headers: { Authorization: "Bearer " + token }
                    };
                    await Axios.post('document/restoreSelectedDocuments', [params.row.ID], config);
                    setForceGridRefresh(prev => !prev);
                    dispatch(updateEntityTree());
                }}
            /> : null}
        </>
    ];


    return (
        <DataGridComponent
            apiRef={apiRef}
            baseURL={"document/getDeletedDocuments"}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            specificActionsColumns={detailSpecificActionsColumns}
            forceGridRefresh={forceGridRefresh}
            initialState={{
                sorting: {
                    sortModel: [{ field: "Filename", sort: "asc" }],
                },
            }}
            paramURL={
                "Filter[OTEntityID]=" + OTEntityID
            }
            getDetailPanelHeight={() => "auto"}
            isAddDisabled={true}
            isEditDisabled={true}
            isDeleteDisabled={true}
            checkboxSelection={inSelection}
            selectionModel={selection}
            onSelectionModelChange={newSelectionModel => {
                setSelection(newSelectionModel);
            }}
            toolbar={{
                newAction: !inSelection ? 
                    <ButtonToolbar
                        type="button"
                        onMouseEnter={deferEnter}
                        onMouseOut={deferLeave}
                        titleTooltip={t("view.document.MoveDocument")}
                        title={t("common.Select")}
                        startIcon={<CheckBoxOutlineBlankIcon />}
                        onClick={handleSelectClick}
                    />
                    :
                    <>
                        <ButtonToolbar
                            titleTooltip={t("view.document.CancelMove")}
                            title={t("common.Cancel")}
                            startIcon={<CancelOutlinedIcon />}
                            onClick={handleCancelMoveClick}
                        />
                        <ButtonToolbar
                            titleTooltip={t("view.document.DownloadSelected")}
                            title={t("common.Restore")}
                            startIcon={<ReplayIcon />}
                            onClick={handleRestoreClick}
                            disabled={!isArrayLength(selection)}
                        />
                    </>
            }}
            {...props}
        />
    );
};

export default RecycleBinGrid;
